var map = {
	"./finish.svg": 30227,
	"./first.svg": 38328,
	"./glmx.svg": 77641,
	"./glsjj.svg": 60726,
	"./jcxx.svg": 36216,
	"./second.svg": 2714,
	"./szsx.svg": 11442
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;